<template>
  <div class="mermaid" data-processed="true" v-html="svgCode" />
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeMount } from 'vue';
import mermaid, { type MermaidConfig } from 'mermaid';

type Theme = 'default' | 'base' | 'dark' | 'forest' | 'neutral' | 'null';

const props = defineProps({
  idx: { type: String, required: true },
  content: { type: String, required: true },
});
const svgCode = ref(null as string | null);
const rootStyles = window.getComputedStyle(document.documentElement);

function setConfigPropertyValue(config: Record<string, string>, property: string, cssVariable: string): void {
  const value = rootStyles.getPropertyValue(cssVariable)?.trim();
  if (value && value !== '') {
    config[property] = value;
  }
}

onBeforeMount(() => {
  const mermaidConfig: MermaidConfig = {
    securityLevel: 'loose',
    startOnLoad: false,
    theme: (rootStyles.getPropertyValue('--dev-docs-mermaid-theme') || 'default') as Theme,
    themeVariables: {},
  };

  setConfigPropertyValue(mermaidConfig.themeVariables, 'fontFamily', '--dev-docs-mermaid-font-family');
  setConfigPropertyValue(mermaidConfig.themeVariables, 'fontWeight', '--dev-docs-mermaid-font-weight');
  setConfigPropertyValue(
    mermaidConfig.themeVariables,
    'primaryColor',
    '--dev-docs-mermaid-theme-variables-primary-color'
  );
  setConfigPropertyValue(
    mermaidConfig.themeVariables,
    'primaryTextColor',
    '--dev-docs-mermaid-theme-variables-primary-text-color'
  );
  setConfigPropertyValue(
    mermaidConfig.themeVariables,
    'primaryBorderColor',
    '--dev-docs-mermaid-theme-variables-primary-border-color'
  );

  mermaid.initialize(mermaidConfig);
});

onMounted(async () => {
  const { svg } = await mermaid.render(props.idx, props.content);
  svgCode.value = svg;
});
</script>
